import cx from 'classnames';
import { Icon } from 'components/Icon';

export type Props = {
  testId?: string;
  className?: string;
  iconClassName?: string;
  defaultStyles?: boolean;
};

export const Loader = ({ testId, className, iconClassName, defaultStyles = false }: Props): JSX.Element => {
  return (
    <div
      className={cx(
        {
          'flex grow justify-center items-center p-32 text-primary-500': defaultStyles,
        },
        className,
      )}
      data-testid={testId}
    >
      <Icon name="Spinner" className={cx(iconClassName, 'animate-spin-step')} />
    </div>
  );
};
